module.exports = __webpack_public_path__ + "static/tips-free-bd1e3f0d9a9d3275ec7036f17ad0238a.png";